/**
 * This submodule handles the state of the
 * add to cart form
 * --- STATES ---
 * There are 4 states:
 * - 'default' : default state when page is loaded
 * - 'adding' : ajax call has been fired to add item to cart
 * - 'added' : ajax call completed successfully and item was added to cart
 * - 'error' : error occurred on ajax call or form validation
 */
define(['addToCartUIHandling'], function(addToCartUIHandling) {
    /**
     * Start of submodule
     */
    let addToCartStateHandler = {
        /**
         * Resets the form to default
         * Disables min/max depending on inputvalue
         * @param {Object} formObject
         */
        setDefaultState: function(formObject) {
            const minQty = parseInt($(formObject).find('.minQuantity').val());
            const maxQty = COSTCO.util.isBDStore() ? 9999 : 999;
            const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
			const inputValue = parseInt(inputField.val());
            if(isNaN(inputValue)) {
                addToCartUIHandling.enableMaxQtyButton(formObject);
                addToCartUIHandling.disableAddToCartButton(formObject);
                return;
            }
            switch(inputValue) {
                case 0:
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.disableAddToCartButton(formObject);
                    break;
                case minQty:
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.enableAddToCartButton(formObject);
                    break;
                default:
                    addToCartUIHandling.enableMinQtyButton(formObject);
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.enableAddToCartButton(formObject);
                    break;
            }
            addToCartUIHandling.hideError(formObject);
        },
        /**
         * Disables all buttons while the
         * ajax call is being fired
         * @param {Object} formObject
         */
        setAddingState: function(formObject) {
            addToCartUIHandling.disableAll(formObject);
        },
        /**
         * Switches the add to cart buttons
         * to fit the added to cart view
         * @param {Object} formObject
         * @param {Object} data
         * @param {Object} serializedDataObject
         */
        setAddedState: function(formObject, data, serializedDataObject) {
            const message = parseInt(data.itemMessage);
            const minimumQuantity = parseInt(serializedDataObject.minQuantity);
            const maximumQuantity = parseInt(serializedDataObject.maxQuantity);
            addToCartUIHandling.switchToAddedToCartView(formObject, message);
            addToCartUIHandling.showAddedToCartMessage(formObject, message);
            if(message <= minimumQuantity) {
                addToCartUIHandling.enableMaxQtyButton(formObject);
                addToCartUIHandling.disableMinQtyButton(formObject);
            } else if(message === maximumQuantity) {
                addToCartUIHandling.enableMaxQtyButton(formObject);
                addToCartUIHandling.enableMinQtyButton(formObject);
            } else {
                addToCartUIHandling.enableMinQtyButton(formObject);
                addToCartUIHandling.enableMaxQtyButton(formObject);
            }
        },
        /**
         * Disables all buttons
         * displays the error
         * @param {Object} formObject
         * @param {String} errorMessage
         */
        setErrorState: function(formObject, errorMessage) {
        	const minQty = parseInt($(formObject).find('.minQuantity').val());
            const maxQty = COSTCO.util.isBDStore() ? 9999 : 999;
        	const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
			const inputValue = parseInt(inputField.val());
			const addToCartDivWrapper = $(formObject).find('.product-quick-buy-btn');
            const productAddedToCart = addToCartDivWrapper.css('display') === 'none';
            if(isNaN(inputValue)) {
                addToCartUIHandling.enableMaxQtyButton(formObject);
                addToCartUIHandling.disableMinQtyButton(formObject);
                addToCartUIHandling.disableAddToCartButton(formObject);
                return;
            }
            if(productAddedToCart){
            	addToCartUIHandling.setInputFieldValue(formObject, (inputValue-minQty));
            	addToCartUIHandling.disableInputField(formObject);
            } else {
            	addToCartUIHandling.enableInputField(formObject);
            }
            switch(inputValue) {
                case 0:
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.disableMinQtyButton(formObject);
                    addToCartUIHandling.disableAddToCartButton(formObject);
                    break;
                case minQty:
                    addToCartUIHandling.disableMinQtyButton(formObject);
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.enableAddToCartButton(formObject);
                    break;
                default:
                    addToCartUIHandling.enableMinQtyButton(formObject);
                    addToCartUIHandling.enableMaxQtyButton(formObject);
                    addToCartUIHandling.enableAddToCartButton(formObject);
                    break;
            }
            addToCartUIHandling.showError(formObject, errorMessage);
        },
    };
    return addToCartStateHandler;
});



// WEBPACK FOOTER //
// ./js/search/addToCartStateHandler.js